import 'css-chunksrc/client/scenes/calendar/dailyView/styles.scss';export default {
  "dailyView": "_dailyView_szyre_1",
  "labels": "_labels_szyre_5",
  "dayName": "_dayName_szyre_11"
};